module.exports = __webpack_public_path__ + "2df3ce246b6501812d2c642159fa3ae4.svg";